import filter from 'lodash/filter';
import reduce from 'lodash/reduce';
import loglevel from 'loglevel';

import {
  isOrderedContentSection, 
  isGridPositionsContentSection, 
  isSingletonContentSection
} from 'zoomforth_codesbane_viewer/lib/sections.js';


const sanitizeSection = (section, pageContentItemsByUuid)=> {

  // TODO: Handle isSingletonContentSection's with broken content

  const newSection = { ...section };

  if (isSingletonContentSection(section)) {
    if (!pageContentItemsByUuid[section.singletonContentUuid]) {
      loglevel.warn(`Singleton section id=${section && section.id} points at invalid content.`);
    }
  }

  if (isOrderedContentSection(section)) {
    newSection.orderedContentUuids = filter(section.orderedContentUuids, uuid => !!pageContentItemsByUuid[uuid]);
  }
  if (isGridPositionsContentSection(section)) {
    newSection.gridPositions = filter(section.gridPositions, ({ uuid })=> !!pageContentItemsByUuid[uuid]);
  }

  return newSection;

};


export default (sectionsById, { pageContentItemsByUuid })=>

  reduce(sectionsById, (accum, section, sectionId)=> (

    {
      ...accum,
      [sectionId]: sanitizeSection(section, pageContentItemsByUuid)
    }

  ), {});



